import React from 'react';
import { Layout } from '../components/Layout/Layout';
import { AdvancedCalendar } from '../components/Advisor/AdvancedCalendar';

export const AdvisorCalendarPage: React.FC = () => {
  return (
    <Layout>
      <div className="p-6">
        <AdvancedCalendar />
      </div>
    </Layout>
  );
};